import React from 'react';
import PropTypes from 'prop-types';
import useImage from '../../hooks/image';

const Image = ({ name, ...props }) => {
  const image = useImage(name);
  return (
    <img
      data-testid="image-loaded"
      width="35px"
      height="35px"
      src={image.src}
      alt={image && image.alt ? image.alt : name}
      {...props}
    />
  );
};

Image.propTypes = {
  name: PropTypes.string,
};

export default Image;
